import React from 'react'
import { ListItemText, MenuItem, Select, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'

interface FilterSelectProps {
  placeholder: string
  value: string[]
  onChange: (value: string[]) => void
  options: string[]
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
  placeholder,
  value,
  onChange,
  options,
}) => {
  return (
    <Select
      displayEmpty
      size="small"
      sx={{ flex: 1, width: 'calc(33.33% - 8px)' }}
      multiple
      value={value}
      onChange={event => {
        const {
          target: { value },
        } = event
        const newValue = typeof value === 'string' ? value.split(',') : value
        onChange(newValue)
      }}
      renderValue={selected => {
        if (selected.length === 0) {
          return (
            <Typography variant="body1" sx={{ fontWeight: 400 }} component="em">
              {placeholder}
            </Typography>
          )
        }

        return selected.join(', ')
      }}
    >
      {options.map((option, index) => (
        <MenuItem key={index} value={option}>
          {value.includes(option) && (
            <CheckIcon sx={{ mr: 1 }} fontSize="small" />
          )}
          <ListItemText primary={option} />
        </MenuItem>
      ))}
    </Select>
  )
}
